<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
<div class="mb-2 text-webbtree-green">
  <a data-testid="auto-companyinfo-a-1" routerLinkActive="active" [routerLink]="['/company-directory/industries']" style="color: inherit;">Industries</a> >
  <span *ngIf="!showEmptyState">
    <a data-testid="auto-companyinfo-a-2" routerLinkActive="active"
      style="color: inherit;"
      [routerLink]="['/company-directory',industry?.split(' ')?.join('-')+'-overview-'+industryid]">
      {{industry}}
      >
    </a>
  </span>
    <a data-testid="auto-companyinfo-a-3" style="color: inherit;">
      {{companyName}}
    </a>
</div>
<div class="row companyinfo" *ngIf="!showEmptyState" style="padding: 0 15px">
  <div class="col-lg-8" style="padding: 0; padding-right: 3px;">
    <!-- Basic Info -->
    <div class="companyinfo-basic companyinfo-card" *ngIf="!expandEmpList">
      <div class="companyinfo-basic-title mb-4">
        <img
          class="companyinfo-companylogo"
          [src]="basicInfo?.companylogo"
          *ngIf="basicInfo?.companylogo"
        />
        <span *ngIf="!basicInfo?.companylogo || basicInfo?.companylogo.length == 0"
        class="
          company-img
          d-flex
          align-items-center
          justify-content-center
          mr-3
          red-circle
        "
        style="border: none !important"
      >
        {{ basicInfo?.companyname?.trim()[0] }}
      </span>
        <p class="mb-0 py-0">{{ basicInfo?.companyname }}</p>
      </div>
      <div class="row">
        <div class="col-lg-5">
          <h2 class="companyinfo-header f-12 font-weight-500 gray-text mb-1">Website</h2>
          <a data-testid="auto-companyinfo-a-4" class="text-webbtree-green font-weight-500" [href]="basicInfo?.website" target="_blank" style="word-wrap: break-word;">Visit Website</a>
        </div>
        <div class="col-lg-4">
          <h2 class="companyinfo-header f-12 font-weight-500 gray-text mb-1">Employees</h2>
          <p *ngIf="basicInfo?.companysize">{{ basicInfo?.companysize }}</p>
          <p *ngIf="!basicInfo?.companysize">-</p>
        </div>
        <div class="col-lg-3">
          <h2 class="companyinfo-header f-12 font-weight-500 gray-text mb-1">Company Revenue</h2>
          <p *ngIf="companyRevenue">USD {{ companyRevenue }}</p>
          <p *ngIf="!companyRevenue">-</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-5">
          <h2 class="companyinfo-header f-12 font-weight-500 gray-text mb-1">Industry</h2>
          <p class="mb-0" *ngIf="basicInfo?.industry">{{ basicInfo?.industry }}</p>
          <p class="mb-0" *ngIf="!basicInfo?.industry">-</p>
        </div>
        <div class="col-lg-4">
          <h2 class="companyinfo-header f-12 font-weight-500 gray-text mb-1">Founded In</h2>
          <p class="mb-0" *ngIf="basicInfo?.yearfounded">{{ basicInfo?.yearfounded }}</p>
          <p class="mb-0" *ngIf="!basicInfo?.yearfounded">-</p>
        </div>
        <div class="col-lg-3">
          <h2 class="companyinfo-header f-12 font-weight-500 gray-text mb-1">Social profiles</h2>
          <a data-testid="auto-companyinfo-a-5" class="text-webbtree-green font-weight-500" *ngIf="basicInfo?.SocialProfile" [href]="basicInfo?.SocialProfile" target="_blank" style="word-wrap: break-word;">
            <i *ngIf="basicInfo.socialprofileislinkedin" class="fab fa-linkedin"></i>
            <i *ngIf="!basicInfo.socialprofileislinkedin" class="fas fa-globe"></i>
          </a>
          <p class="mb-0" *ngIf="!basicInfo?.SocialProfile">-</p>
        </div>
      </div>
    </div>
    <!-- Tabs -->
    <div class="companyinfo-card border-blue p-0" style="display: flex;">
        <a data-testid="auto-companyinfo-a-6" class="companyinfo-btn" style="color: #2E93A1!important;"  (click)="switchTab(0)" [class.companyinfo-unlockdetails] = "showtab===0"><i class="fas fa-users" style="margin-right: 5px;"></i>Employee Details</a>
        <a data-testid="auto-companyinfo-a-7" class="companyinfo-btn" style="color: #2E93A1!important;"  (click)="switchTab(1)" [class.companyinfo-unlockdetails] = "showtab===1"> <i class="fas fa-sack-dollar" style="margin-right: 5px;"></i>Salaries</a>
    </div>
    <!-- Employee List -->
    <div class="companyinfo-card"  *ngIf="showtab===0">
      <div class="companyinfo-flex">
        <p (click)="switchEmpListView(false)"
         *ngIf="expandEmpList"
          class="companyinfo-unlockdetails companyinfo-flex">
          Back to profile
        </p>
        <div *ngIf="expandEmpList" class="gray-text">
          {{ start + 1 }} - {{ end }} of {{ totalCount }}
        <i class="fas fa-caret-left f-16 ml-1" (click)="pagination('prev')"></i>
        <i
          class="fas fa-caret-right f-16"
          (click)="pagination('next')"
          style="margin-left: 25px"
        ></i>
        </div>
      </div>
      <div class="">
        <div class="mb-3 d-flex justify-content-between">
          <div class="pr-3">
            <h1 class="companyinfo-datafound mb-0"> {{companyName}} Employee Contacts</h1>
          </div>
          <div class="pl-3">
            <span class="clearall-btn text-webbtree-green" (click)="applyFilter('clearall', '')"><i class="fas fa-redo-alt" ></i></span>
          </div>
        </div>
        <div class="mb-4">
          <div class="col">
           <div class="row">
             <div class="col pl-0">
              <input data-testid="auto-companyinfo-input-1" type="text"
                placeholder="Jobtitle"
                [(ngModel)] = "jobtitle"
                (input)="onKeyPress(jobtitle)"
                class=" wc-form-control"
                [matAutocomplete]="company_name" >
              <mat-autocomplete #company_name="matAutocomplete">
                <mat-option *ngFor="let jobtitle of filteredJobTitleList.slice(0,10)" [value]="jobtitle"
                 (onSelectionChange)="applyFilter('jobtitle',jobtitle)"
                 >
                  {{jobtitle}}
                </mat-option>
              </mat-autocomplete>
             </div>
             <div class="col px-0">
              <div>
                <select data-testid="auto-companyinfo-select-1"
                  (ngModelChange)="applyFilter('city', $event)"
                  class=" wc-form-control  wc-select text-capitalize"
                  [(ngModel)]="city"
                >
                  <option disabled selected value="">City</option>
                  <option *ngFor="let city of cityList" [value]="city">
                    {{ city }}
                  </option>
                </select>

              </div>
             </div>
            <div class="col pr-0">
              <select data-testid="auto-companyinfo-select-2"

              (ngModelChange)="applyFilter('country', $event)"
              [(ngModel)]="country"
              class=" text-capitalize wc-form-control wc-select"
            >
              <option disabled selected value="">Country</option>
              <option *ngFor="let country of countryList" [value]="country">
                {{ country }}
              </option>
            </select>
            </div>
           </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="showtab===0 && emplList?.totalCount > 0">
        <div class="col-lg-4 companyinfo-header">Name</div>
        <div class="col-4 companyinfo-header">Contact Details</div>
        <!-- <div class="px-3 companyinfo-header" style="width: 182px;">Status</div> -->
      </div>
      <div class="row companyinfo-emplist-row" *ngFor="let emp of emplList?.message; let count = index">
        <div class="col-lg-4">
          <p class="companyinfo-emplist-name mb-2">{{ emp?.firstname }} {{emp?.lastname}}</p>
          <p class="text-capitalize mb-1 f-12" style="margin-bottom: 3px">{{ emp?.jobtitle}}<span *ngIf="emp?.industry">,</span> {{ emp?.industry }}</p>
          <p class="text-capitalize mb-0 f-12"> {{ emp?.workcity || emp?.city }} <span *ngIf="emp?.workcity || emp?.city ">,</span>
              {{ emp?.workcountry || emp?.country }}</p>
          <div class="" [ngClass]="{'mt-2':emp?.enricheddetails?.socialprofilesarray.length>0}">
            <a data-testid="auto-companyinfo-a-8" [title]="social.platformname" class="social-links" style="color: #2E93A1" [href]="social.link" target="_blank" *ngFor="let social of emp?.enricheddetails?.socialprofilesarray">
              <i class="text-webbtree-green" style="margin-right: 5px;" [class]="social?.icon"></i>
            </a>
          </div>
        </div>
        <div class="col-lg-4 companyinfo-unlockdetails text-truncate" style="font-weight: 400;">

          <div class="onhovercopy d-flex" *ngFor="let email of emp?.enricheddetails?.emailsarray">
            <p [class.companyinfo-unlockedcontact]="emp?.unlocked"  >
              {{ email }}
            </p>
            <span *ngIf="emp?.unlocked" title="Copy Email" class="text-webbtree-green" (click)="copyText(email, 'email')">
              <i class="far fa-copy px-3"></i>
            </span>
          </div>

          <p *ngFor="let contact of emp?.enricheddetails?.contactnumbersarray" class="onhovercopy" [class.companyinfo-unlockedcontact]="emp?.unlocked">{{ contact }} <span *ngIf="emp?.unlocked" title="Copy contact number" class="text-webbtree-green" (click)="copyText(contact, 'contact')"><i class="far fa-copy px-3"></i></span></p>

          <p class="gray-text  font-weight-normal"  *ngIf="(emp?.enricheddetails?.emailsarray?.length == 0) && (emp?.enricheddetails?.contactnumbersarray?.length == 0) ">
            Contact Details Not Available
          </p>
        </div>
        <div class="px-3" *ngIf="!emp?.unlocked">
          <button data-testid="auto-companyinfo-button-1" *ngIf="emp?.unlocked !='true' && currentUnlockedUser!=emp?.createdcandidatenumber && (emp?.enricheddetails?.contactnumbersarray.length>0 || emp?.enricheddetails?.emailsarray.length>0) " class="btn-trms-white" (click)="unlockCandidate(emp)">
            <i style="margin-right: 5px;" class="fas fa-lock"></i>
            Reveal contact
          </button>
          <button data-testid="auto-companyinfo-button-2" *ngIf="isLoading && currentUnlockedUser==emp?.createdcandidatenumber" class="btn-trms-white">
            <div class="spinner"><div></div><div></div><div></div><div></div></div>
          </button>
        </div>
        <div *ngIf="emp?.unlocked && (emp?.enricheddetails?.contactnumbersarray.length>0 || emp?.enricheddetails?.emailsarray.length>0)" style="text-align: center; margin-left: 41px;">
          <i class="fal fa-check" style="margin-right: 5px; color: #229300;" ></i>Revealed
        </div>
      </div>
      <div class="companyinfo-emplist-link" *ngIf="emplList?.totalCount > 0" >
        <ngb-pagination class="d-flex justify-content-center"
        *ngIf="expandEmpList"
        [collectionSize]="totalCount"
        [(page)]="activePage"
        [maxSize] = "5"
        [pageSize]="20"
        [boundaryLinks]="true"
        (pageChange)="pagination('page', $event)"></ngb-pagination>
        <a data-testid="auto-companyinfo-a-9" class="f-14" (click)="switchEmpListView(true)" *ngIf="!expandEmpList && emplList?.totalCount > 5">View more {{emplList?.totalCount - 5}} contacts</a>
      </div>
    </div>
    <div  class="companyinfo-card text-center  mb-0 f-16" *ngIf="showtab===0 && emplList?.totalCount == 0" >
      <p class="gray-text font-weight-normal">Employee Details Not Available</p>
    </div>
    <!-- Salary Data -->
    <div class="companyinfo-card" *ngIf="showtab===1">
      <div class="companyinfo-expandsal">
        <app-salarylist
        companyId="{{companyId}}"
        companyName="{{companyName}}"
        [loginModal]="loginModal"
        >
        </app-salarylist>

      </div>
    </div>
    <!-- Visualisations -->
    <div class="companyinfo-card" *ngIf="!expandEmpList">
      <h2 class="companyinfo-boldheader">Department-wise Distribution at {{companyName}}</h2>
      <fusioncharts
      type="scrollbar2d"
      width="100%"
      height="450"
      [dataSource]="dataSourceFunctions"
    >
    </fusioncharts>
    <p style=" font-size: 10px;color: #777;">
      <i style=" color: #2e93a1;" class="fas fa-info-circle"></i>
      Webbtree regularly monitors statistics reported within data centre and makes updates occasionally to ensure quality reporting. If you have questions about your companies analytics on Webbtree, please <span style="color: #2e93a1">contact support&#64;webbtree.com</span></p>
    </div>
    <div class="companyinfo-card" *ngIf="!expandEmpList">
      <h2 class="companyinfo-boldheader">Gender Distribution at {{companyName}}</h2>
      <fusioncharts type="pie2d" width="100%" [dataSource]="dataSourceGender">
      </fusioncharts>
      <p style=" font-size: 10px;color: #777;">
        <i style=" color: #2e93a1;" class="fas fa-info-circle"></i>
        Webbtree regularly monitors statistics reported within data centre and makes updates occasionally to ensure quality reporting. If you have questions about your companies analytics on Webbtree, please <span style="color: #2e93a1">contact support&#64;webbtree.com</span></p>
    </div>
  </div>
  <div class="col-lg-4" style="padding: 0;">
    <!-- Company Overview -->
    <div class="companyinfo-card" *ngIf="!expandEmpList">
      <h2 class="companyinfo-header mb-1 f-12 font-weight-500 gray-text">About {{companyName}}</h2>
      <p *ngIf="basicInfo?.overview && showtext" class="line-height-1 mb-2 pointer">{{ basicInfo?.overview.slice(0,200) }}</p>
      <p *ngIf="basicInfo?.overview && !showtext" class="line-height-1 mb-2 pointer">{{ basicInfo?.overview }}</p>
      <p class="text-webbtree-green pointer" *ngIf="basicInfo?.overview?.length>200" (click)="showtext = !showtext">{{showtext ? 'Read more': 'Read less'}}</p>
      <p *ngIf="!basicInfo?.overview" class="gray-text  font-weight-normal">Overview Not Available</p>

      <h2 class="companyinfo-header mb-1 mt-1 f-12 font-weight-500 gray-text" [class.mt-5]="basicInfo?.overview?.length<=200">
        {{companyName}} Location
      </h2>
      <div *ngIf="basicInfo?.city || basicInfo?.country">
        <p style="margin-bottom: 3px">{{ basicInfo?.city }}</p>
        <p style="margin-bottom: 3px">{{ basicInfo?.country }}</p>
        <p class="mb-0">{{ basicInfo?.countrycode }}</p>
      </div>
      <p *ngIf="!(basicInfo?.city || basicInfo?.country)" class="gray-text  font-weight-normal">
        Location Details Not Available
      </p>
    </div>
    <!-- Similar Companies -->
    <div class="companyinfo-card companyinfo-similarCompanies">
      <h2 class="companyinfo-boldheader mb-1" >Similar Companies to {{companyName}}</h2>
      <div class="row mt-3" *ngFor="let company of similarCompanies; let i = index">
        <div class="pl-3">
          <img class="companyinfo-companylogo" *ngIf="company.companylogo" [src]="company.companylogo" />
          <span *ngIf="!company.companylogo"
            class="
              company-img
              d-flex
              align-items-center
              justify-content-center
            "
            [ngClass]="{
              'red-circle': i % 4 == 0,
              'yellow-circle': i % 4 == 1,
              'green-circle': i % 4 == 2,
              'blue-circle': i % 4 == 3
            }"
            style="border: none !important"
          >
            {{ company.companyname.trim()[0] }}
          </span>
        </div>
        <div class="col">
          <p class="text-black font-weight-600 mb-0">
            <a data-testid="auto-companyinfo-a-10"  target="_blank" routerLinkActive="active" [routerLink]="['/company-directory', company?.companyname, company?.companyid]">{{company.companyname }}</a>
          </p>
          <p class="mb-0 f-12">{{ company.industry }}</p>
        </div>
      </div>
    </div>
    <div class="companyinfo-card pr-70" *ngIf="showSalaryWidget && showtab==0">
      <h2 class="companyinfo-boldheader mb-1">Salaries at {{companyName}}</h2>
      <div *ngFor="let salary of salaryList" >
       <div class="companyinfo-salarycard" *ngIf="salary?.finalSalary">
          <div>
            <p class="companyinfo-salarycard-salary" (click)="switchTab(1)"  >$ {{salary?.finalSalary}}</p>
            <p class="companyinfo-salarycard-jobtitle text-capitalize">{{salary?.jobtitle}}</p>
          </div>
          <div>
            <p class="companyinfo-salarycard-salcount" *ngIf="salary?.salcount && salary?.salcount>1">
              {{salary?.salcount}} salaries available
            </p>
            <p class="companyinfo-salarycard-salcount" *ngIf="salary?.salcount && salary?.salcount==1">
              {{salary?.salcount}} salary available
            </p>
          </div>
       </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showEmptyState" class="companypages-emptystate">
  <img src="https://previewresume.s3.ap-south-1.amazonaws.com/pq16brgnh" alt="Empty-state" /> <br/>
  <p>No company data was found here</p>
</div>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success"  (close)="successMessage = ''" >
  <span class="successCheck"><i class="fal fa-check"></i> </span>
 <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage"   type="danger"  (close)="errorMessage = ''">
 <span class="errorCheck"><i class="fal fa-times"></i></span>
 <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

